import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import CenteredSpinner from '@shared/CenteredSpinner';

import { wipeCredentials } from '~/util/auth';

import { useQuery } from '../../../../effects/useQuery';
import { useNumaAuth0 } from './auth0Util';
import { getSafeDestination } from './constants';

export const Auth0Redirect = () => {
  const history = useHistory();
  const { attemptSilentAuth0Login } = useNumaAuth0();

  const { redirectTo } = useQuery();

  useEffect(() => {
    attemptSilentAuth0Login({
      onSuccess: () => {
        if (typeof redirectTo === 'string') {
          history.push(getSafeDestination(redirectTo));
        } else {
          history.push('/inbox');
        }
      },
      onFailure: () => {
        wipeCredentials();
      },
    });
  }, [history, redirectTo, attemptSilentAuth0Login]);

  return <CenteredSpinner />;
};
